import { makeStyles } from '../../../../../../../../styles';
export const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1),
    },
    list: {
        display: 'flex',
        flexDirection: 'column',
        maxHeight: 200,
        overflow: 'auto',
    },
    listItem: {
        display: 'flex',
        gap: theme.spacing(1),
        alignItems: 'center',
        cursor: 'pointer',
        padding: theme.spacing(1),
        borderRadius: theme.spacing(1),
        '&:hover': {
            backgroundColor: theme.colors.gray[100],
        },
    },
    noOptions: { padding: theme.spacing(1) },
}));
//# sourceMappingURL=AddFilterMenuContent.styles.js.map